import { Component } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { BaseTableComponent } from '../base/base-table/base-table.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css', './../base/base-table/base-table.component.css']
})
export class HomeComponent extends BaseTableComponent {
  title = 'CDC Create a Player';
  isSummary: boolean = true;
  league: string = "NHL";
  season: number = 4;
  players: Observable<any[]>;

  constructor(private firestore: AngularFirestore) { 
    super();
  }

  ngOnInit() {
    this.getData();
  }
  
  getData() {
    this.players = this.firestore.collection("players", ref => ref.where('Season', '==', this.season).orderBy("ID", "asc")).valueChanges();
  }

  updateSeason(event) {
    this.season = Number(event.target.value);
    this.getData();
  }
}
